module.exports = __webpack_public_path__ + "static/img/weixuanzhongdonghua.png@2x.e883eff8.png";